import { render } from "./page6.vue?vue&type=template&id=455f4612&scoped=true"
import script from "./page6.vue?vue&type=script&lang=js"
export * from "./page6.vue?vue&type=script&lang=js"

import "./page6.vue?vue&type=style&index=0&id=455f4612&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455f4612"]])

export default __exports__